import firebase from '../../firebase/index';
import {actionTypes} from 'redux-resource';

const RESOURCE_NAME = 'users';

function securityUpdate(id, values, dispatch) {
	dispatch({
		type: actionTypes.UPDATE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'update',
		resources: [id]
	});

	return firebase.database()
		.ref(`${RESOURCE_NAME}/${id}/security`)
		.update(values)
		.then(() => {
			const entity = {id, ...values};

			dispatch({
				type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
				resourceName: RESOURCE_NAME,
				request: 'update',
				resources: [entity]
			});

			return entity;
		})
		.catch(error => {
			dispatch({
				type: actionTypes.UPDATE_RESOURCES_FAILED,
				resourceName: RESOURCE_NAME,
				request: 'update'
			});

			return error;
		});
}

/** @function Set user as confirmed normal admin user */
export const blessUser = id => dispatch => securityUpdate(
	id, {confirmed: true}, dispatch
);

/** @function Set user as fully privileged admin user */
export const sanctifyUser = id => dispatch => securityUpdate(
	id, {privileged: true}, dispatch
);

/** @function Set user as confirmed normal admin user */
export const disgraceUser = id => dispatch => securityUpdate(
	id, {privileged: false}, dispatch
);

/** @function Remove all privileges from user */
export const curseUser = id => dispatch => securityUpdate(
	id, {confirmed: false, privileged: false}, dispatch
);

export const readUsers = () => dispatch => {
	dispatch({
		type: actionTypes.READ_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		request: 'all'
	});

	return firebase.database().ref(RESOURCE_NAME)
		.once('value')
		.then(snapshot => {
			const resources = [];

			snapshot.forEach(child => {
				const {security, meta} = child.val();

				resources.push({id: child.key, ...meta, ...security});
			});

			dispatch({
				type: actionTypes.READ_RESOURCES_SUCCEEDED,
				resourceName: RESOURCE_NAME,
				request: 'all',
				list: 'all',
				resources
			});

			return resources;
		})
		.catch(error => {
			dispatch({
				type: actionTypes.READ_RESOURCES_FAILED,
				resourceName: RESOURCE_NAME,
				request: 'all'
			});

			throw error;
		});
};

export const deleteUser = id => dispatch => {
	dispatch({
		type: actionTypes.DELETE_RESOURCES_PENDING,
		resourceName: RESOURCE_NAME,
		resources: [id]
	});

	return firebase.database()
		.ref(`${RESOURCE_NAME}/${id}`)
		.remove()
		.then(() => {
			dispatch({
				type: actionTypes.DELETE_RESOURCES_SUCCEEDED,
				resourceName: RESOURCE_NAME,
				resources: [id]
			});
		})
		.catch(error => {
			dispatch({
				type: actionTypes.DELETE_RESOURCES_FAILED,
				resourceName: RESOURCE_NAME,
				request: 'delete'
			});

			throw error;
		});
};



// WEBPACK FOOTER //
// ./src/client/redux/actions/users.js